import { Typography as MTypography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { FORTA_WHITE, FORTA_ORANGE } from '../../utils/colors';

import type { TypographyProps as MTypographyProps } from '@mui/material';

interface FTypographyProps extends MTypographyProps {
  error?: boolean;
}

const StyledTypography = styled(MTypography, {
  shouldForwardProp: (prop) => prop !== 'error',
})<FTypographyProps>(({ error }) => ({
  '&:before': error
    ? {
        content: '"!"',
        width: 21,
        height: 21,
        backgroundColor: FORTA_ORANGE,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        color: FORTA_WHITE,
        fontWeight: 'bold',
        borderRadius: '50%',
        position: 'absolute',
        left: -22,
        top: 0,
        bottom: 0,
        textAlign: 'center',
      }
    : {},
}));

const FTypography = (props: FTypographyProps) => {
  const { children, error = false } = props;

  return (
    <StyledTypography {...props} error={error} style={{ position: 'relative' }}>
      {children}
    </StyledTypography>
  );
};

export default FTypography;
